import React, { Component } from 'react';
import StabSearchBox from '../StabSearchBox';
import ReactSearchBox from '../ReactSearchBox';
import { Experiment } from '../Experiment';

class SearchBox extends Component {
  render() {
    return (
      <Experiment name={'HA_PTA_HP_StayzOnPlatform'}>
        {value => value !== 0 ? <ReactSearchBox /> : <StabSearchBox />}
      </Experiment>
    );
  }
}

export default SearchBox;
